import { AppAdsFilter } from '../AppAds/AppAds.model';
import { ISelectItem } from '../Select';

export const filterSelectItems: ISelectItem[] = [
	{
		id: 0,
		value: AppAdsFilter.Realty,
		title: 'Недвижимость',
	},
	{
		id: 1,
		value: AppAdsFilter.Vehicle,
		title: 'Транспорт',
	},
	{
		id: 2,
		value: AppAdsFilter.Clothes,
		title: 'Одежда',
	},
	{
		id: 3,
		value: AppAdsFilter.Other,
		title: 'Разное',
	},
];

export const filterCarModelItems: ISelectItem[] = [
	{
		id: 0,
		value: 'toyota',
		title: 'Toyota',
	},
	{
		id: 1,
		value: 'nissan',
		title: 'Nissan',
	},
	{
		id: 2,
		value: 'honda',
		title: 'Honda',
	},
	{
		id: 3,
		value: 'mazda',
		title: 'Mazda',
	},
	{
		id: 4,
		value: 'mercedes',
		title: 'Mercedes',
	},
	{
		id: 5,
		value: 'bmw',
		title: 'BMW',
	},
	{
		id: 6,
		value: 'audi',
		title: 'Audi',
	},
];

export const filterRealtyTypeItems: ISelectItem[] = [
	{
		id: 0,
		value: 'house',
		title: 'Дом',
	},
	{
		id: 1,
		value: 'apartment',
		title: 'Квартира',
	},
	{
		id: 2,
		value: 'room',
		title: 'Комната',
	},
	{
		id: 3,
		value: 'land',
		title: 'Земельный участок',
	},
	{
		id: 4,
		value: 'garage',
		title: 'Гараж',
	},
	{
		id: 5,
		value: 'commercial',
		title: 'Коммерческая недвижимость',
	},
	{
		id: 6,
		value: 'cottage',
		title: 'Дача',
	},
];

export const filterClothesTypeItems: ISelectItem[] = [
	{
		id: 0,
		value: 'shirt',
		title: 'Футболка',
	},
	{
		id: 1,
		value: 'pants',
		title: 'Штаны',
	},
	{
		id: 2,
		value: 'jacket',
		title: 'Куртка',
	},
];

export const filterOtherTypeItems: ISelectItem[] = [
	{
		id: 0,
		value: 'item',
		title: 'Предметы',
	},
	{
		id: 1,
		value: 'food',
		title: 'Еда',
	},
];

export const sortSelectItems: ISelectItem[] = [
	{
		id: 0,
		value: 'price asc',
		title: 'По возрастанию цены',
	},
	{
		id: 1,
		value: 'price desc',
		title: 'По убыванию цены',
	},
];
